import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAgentContext } from '../contexts/AgentContext';
import type { AgentPageContext } from '../types';

export function usePageAgentContext(context: Omit<AgentPageContext, 'route'>): void {
  const { pathname } = useLocation();
  const { setPageContext } = useAgentContext();
  const serialisedContext = JSON.stringify({
    pageId: context.pageId,
    pageTitle: context.pageTitle,
    viewMode: context.viewMode,
    filters: context.filters ?? {},
    visibleSections: context.visibleSections ?? [],
    suggestedPrompts: context.suggestedPrompts ?? [],
  });

  const stableContext = useMemo(
    () => ({
      ...(JSON.parse(serialisedContext) as Omit<AgentPageContext, 'route'>),
      route: pathname,
    }),
    [serialisedContext, pathname]
  );

  useEffect(() => {
    setPageContext(stableContext);
  }, [setPageContext, stableContext]);
}
